localStorage.setItem('baseUrl', String(process.env.REACT_APP_TRACKING_BASE_API_URL));

import("./bootstrap")